import {
  getCompId,
  getExternalId,
} from '@wix/communities-blog-client-common/dist/src/selectors/search-params-selectors';
import { getViewMode } from '../selectors/view-mode-selectors';

export const APP_SETTINGS_DEFAULT_COMP_ID = 'default';
export const APP_SETTINGS_DEFAULT_VIEW_MODE = 'site';
export const APP_SETTINGS_DEFAULT_EXTERNAL_ID = '';

export const parseAppSettings = ({ compId, viewMode, externalId } = {}, state) => ({
  compId: compId || (state && getCompId(state)) || APP_SETTINGS_DEFAULT_COMP_ID,
  viewMode: viewMode || (state && getViewMode(state)) || APP_SETTINGS_DEFAULT_VIEW_MODE,
  externalId: externalId || (state && getExternalId(state)) || APP_SETTINGS_DEFAULT_EXTERNAL_ID,
});
